import React from 'react'
import { TextField, FormControl, Grid, MenuItem, Button } from '@mui/material';

import { LinearLoading, CustomAutocomplete } from 'common'

export const FilterForm = ({ useFetchInit }) => {

    const {
        Forms,
        FetchData,
        Actions,
        Helpers
    } = useFetchInit

    const { FilterForm } = Forms
    const { formState } = FilterForm

    const { fetchSpecificTransactionCashier, fetchAllCashRegisters, fetchAllTranscationsCasher } = FetchData
    const { loadingFetchSpecificTransactionCashier } = fetchSpecificTransactionCashier
    const { cashRegisters } = fetchAllCashRegisters

    const { summaryTransactionsCashier } = fetchAllTranscationsCasher

    const {
        onSubmitFilterForm,
        handleChangeStartDate,
        handleChangeEndDate,
        handleChangeIdCaja,
        handleChangeMovimientoTipo,
        handleClickPrintReport
    } = Actions

    const { formatMoney } = Helpers

    const ingresosQ = summaryTransactionsCashier?.ingresos?.quetzales ?? 0
    const ingresosUSD = summaryTransactionsCashier?.ingresos?.dolares ?? 0
    const egresosQ = summaryTransactionsCashier?.egresos?.quetzales ?? 0
    const egresosUSD = summaryTransactionsCashier?.egresos?.dolares ?? 0
    const balanceQ = summaryTransactionsCashier?.balance?.quetzales ?? 0
    const balanceUSD = summaryTransactionsCashier?.balance?.dolares ?? 0
    const fullBalanceQ = summaryTransactionsCashier?.fullBalance?.quetzales ?? 0
    const fullBalanceUSD = summaryTransactionsCashier?.fullBalance?.dolares ?? 0
    const historyBalanceQ = summaryTransactionsCashier?.fullBalance?.historico_quetzales ?? 0
    const historyBalanceUSD = summaryTransactionsCashier?.fullBalance?.historico_dolares ?? 0

    return (
        <>
            {loadingFetchSpecificTransactionCashier && (<LinearLoading />)}

            <form onSubmit={onSubmitFilterForm}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="startDate">* Fecha de inicio</label>
                            <TextField
                                id='startDate'
                                name='startDate'
                                value={formState.startDate}
                                onChange={handleChangeStartDate}
                                size='small'
                                placeholder='Fecha de inicio'
                                type='date'
                                variant='outlined'
                                hiddenLabel
                                InputProps={{ readOnly: false }}
                                required
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="endDate">* Fecha fin</label>
                            <TextField
                                id='endDate'
                                name='endDate'
                                value={formState.endDate}
                                onChange={handleChangeEndDate}
                                size='small'
                                placeholder='Fecha de finalización'
                                type='date'
                                variant='outlined'
                                hiddenLabel
                                InputProps={{ readOnly: false }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <div className="pt-4"></div>

                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="idcaja">Caja</label>

                            <CustomAutocomplete
                                customId="idcaja"
                                customName="idcaja"
                                customValue={formState.idcaja}
                                customOnChange={(target, value) =>
                                    handleChangeIdCaja({ target: { name: 'idcaja', value: value.value } })
                                }
                                customPlaceholder='Seleccionar caja'
                                customOptions={[
                                    { value: 'ALL', name: 'Todas las cajas' },
                                    ...cashRegisters.map(({ idcaja, descripcion_corta }) => ({
                                        value: String(idcaja),
                                        name: descripcion_corta
                                    }))
                                ]}
                                customDisableClearable={true}
                                customDisabled={false}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="movimiento_tipo">Tipo</label>

                            <TextField
                                id="movimiento_tipo"
                                name="movimiento_tipo"
                                value={formState.movimiento_tipo}
                                onChange={handleChangeMovimientoTipo}
                                select
                                size="small"
                                variant="outlined"
                                hiddenLabel
                                InputProps={{ readOnly: false }}
                            >
                                <MenuItem value='ALL'>MOVIMIENTOS (INGRESO + EGRESO)</MenuItem>
                                <MenuItem value='INGRESO'>INGRESO</MenuItem>
                                <MenuItem value='EGRESO'>EGRESO</MenuItem>
                            </TextField>
                        </FormControl>
                    </Grid>
                </Grid>

                {/* ✅ NUEVO: Resumen read-only debajo de los selectores */}
                <div className="pt-3"></div>
                <Grid
                    container
                    spacing={2}
                    sx={{
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Grid item xs={12} md={2}>
                        <div style={{ border: '1px solid #ddd', borderRadius: 6, padding: 10 }}>
                            <strong>Total Ingresos</strong>
                            <div>Q. {formatMoney(ingresosQ)}</div>
                            <div>$ {formatMoney(ingresosUSD)}</div>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <div style={{ border: '1px solid #ddd', borderRadius: 6, padding: 10 }}>
                            <strong>Total Egresos</strong>
                            <div>Q. {formatMoney(egresosQ)}</div>
                            <div>$ {formatMoney(egresosUSD)}</div>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <div style={{ border: '1px solid #ddd', borderRadius: 6, padding: 10 }}>
                            <strong>Balance (I - E)</strong>
                            <div>Q. {formatMoney(balanceQ)}</div>
                            <div>$ {formatMoney(balanceUSD)}</div>
                        </div>
                    </Grid>
                    
                    <Grid item xs={12} md={2}>
                        <div style={{ border: '1px solid #ddd', borderRadius: 6, padding: 10 }}>
                            <strong>Balance Historico</strong>
                            <div>Q. {formatMoney(historyBalanceQ)}</div>
                            <div>$ {formatMoney(historyBalanceUSD)}</div>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <div style={{ border: '1px solid #ddd', borderRadius: 6, padding: 10 }}>
                            <strong>Balance Total</strong>
                            <div>Q. {formatMoney(fullBalanceQ)}</div>
                            <div>$ {formatMoney(fullBalanceUSD)}</div>
                        </div>
                    </Grid>
                </Grid>

                <div className="pt-4"></div>

                <Grid container justifyContent="center" alignItems="center">
                    <Grid item>
                        <Button
                            style={{ background: "#4b4b4c" }}
                            variant="contained"
                            type='button'
                            onClick={handleClickPrintReport}
                            disabled={false}
                        >
                            <i className="fas fa-print"></i> &nbsp; Imprimir
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}